import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const PrechargeResistorCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-precharge-resistor-calculator" />;

export default PrechargeResistorCalculatorGuidePage;
